import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import CoreComponent from '../../core/CoreComponent.vue';
import LoadingDots from '@/dow-platform/components/commerce/shared/loading-dots/index.js';
import ConfirmRegistration from '../../ui/site-login/ConfirmRegistration.vue';
import DcAlert from '../forms/DcAlert.vue';
export default {
  extends: CoreComponent,
  data() {
    return {
      showError: false,
      showInternalError: false,
      showExternalError: false,
      hideRedirect: false,
      baseURL: window.ciamLoginURL
    };
  },
  components: {
    LoadingDots,
    ConfirmRegistration,
    DcAlert
  },
  methods: {
    loginClick() {
      this.$store.commit('loading/setLoading', true);
      if (window.location.search.indexOf('redirectUrl') > -1) {
        const urlParams = new URLSearchParams(window.location.search);
        const redirectValue = urlParams.get('redirectUrl');
        const goto = encodeURIComponent(window.location.origin + window.location.pathname + '?redirectUrl=' + encodeURIComponent(decodeURIComponent(redirectValue)));
        window.location.href = window.ciamLoginURL.replace('{0}', this.languageCode).replace('{1}', goto);
      } else {
        const goto = encodeURIComponent(window.location.origin + window.location.pathname + window.location.search);
        window.location.href = window.ciamLoginURL.replace('{0}', this.languageCode).replace('{1}', goto);
      }
    },
    getLabel(key) {
      return window.Granite.I18n.get(key);
    },
    getExternalLabel(key) {
      return window.Granite.I18n.get(key).replace("{0}", this.languageCode).replace("{1}", "support/general-inquiries-other.html");
    },
    async login() {
      return await this.$store.dispatch('user/loginCIAMUser').then(() => {
        if (this.reauthorizationRequired) {
          this.$store.commit('loading/setLoading', false);
          return;
        }
        this.$store.dispatch('user/loginRedirect').then(() => {});
      }).catch(error => {
        if (error.response.data.errorCode == 400) {
          this.showError = false;
          this.showInternalError = false;
          this.showExternalError = false;
          this.hideRedirect = true;
          this.hideRightSide(false);
        } else if (error.response.data.errorCode == 401) {
          this.loginClick();
        } else if (error.response.data.errorCode == 404 && error.response.data.message.includes("Internal")) {
          this.showInternalError = true;
          this.hideRedirect = true;
        } else if (error.response.data.errorCode == 404 && error.response.data.message.includes("External")) {
          this.showExternalError = true;
          this.hideRedirect = true;
        } else {
          this.showError = true;
          this.hideRedirect = true;
        }
        this.$store.commit('loading/setLoading', false);
      });
    },
    hideRightSide(isHide) {
      var loginInfoSection = document.getElementById("in-page-login-info");
      var loginContainerSection = document.getElementById("in-page-login-wrap");
      if (isHide) {
        if (loginInfoSection) {
          loginInfoSection.style.display = 'none';
        }
      } else {
        if (loginInfoSection) {
          loginInfoSection.style.display = 'block';
        }
      }
    }
  },
  mounted() {
    this.hideRightSide(true);
    this.$store.commit('loading/setLoading', true);
    this.$store.dispatch('user/updateDccUserInfo').then(() => {
      if (this.$store.state.user.isAuthenticated) {
        this.$store.commit('loading/setLoading', false);
        this.$store.dispatch('user/loginRedirect');
      } else if (!this.$store.state.user.isAuthenticated) {
        this.login();
      } else {
        this.showError = true;
      }
    });
  },
  computed: {
    languageCode() {
      return this.$store.state.browser.languageCode;
    },
    reauthorizationRequired() {
      return this.$store.state?.user?.reauthorizationRequired;
    },
    loading() {
      return this.$store.state.user?.loading;
    },
    userLoggedOut() {
      return this.$store.state.user?.hasTimedOut;
    }
  }
};